// pages/Dashboard.jsx
import Login from "../../components/home/authComponents/Login";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <Login />
    </HomeLayout>
  );
}
